import React from "react";
import styles from "./Row.module.sass";
import cn from "classnames";
import Balance from "../../../../components/Balance";

import { numberWithCommas } from "../../../../utils.js";

const Row = ({ item, setActive }) => {
	const onClick = () => {
		setActive(item);
	};
	return (
		<>
			<div className={styles.row}>
				<div className={styles.col}></div>
				<div className={styles.col}>
					<div className={styles.item} onClick={onClick}>
						<div className={styles.preview}>
							<img src={item.image} alt="Product" />
						</div>
						<div className={styles.details}>
							<div className={styles.product}>{item.name}</div>
						</div>
					</div>
				</div>
				<div className={styles.col}>
					<div className={styles.label}>Products</div>
					{<div className={styles.rating}>{item.nftTemplates.length}</div>}
				</div>
				<div className={styles.col}>
					<div className={styles.label}>Vol 24h</div>
					<div className={styles.sales}>
						<div className={styles.number}>
							${numberWithCommas(item.sales || 0)}
						</div>
						<Balance className={styles.balance} value={item.balance || 0} />
					</div>
				</div>
				<div className={styles.col}>
					<div className={styles.label}>Owner</div>
					<div className={styles.box}>
						<div className={styles.number}>
							{(item.views || 1 / 1000).toFixed(0)}k
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Row;
